<template>
  <CountryPage country="indonesia" />
</template>